type GetTruncateMaxLinesStyle = (maxLines?: number, wordBreak?: boolean) => any;

export const getTruncateMaxLinesStyle: GetTruncateMaxLinesStyle = (
  maxLines = 1,
  breakAll = true,
) => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: maxLines,
  overflow: 'hidden',
  display: '-webkit-box',
  // TODO use break-word instead of normal
  wordBreak: breakAll ? 'break-all' : 'normal',
});
